module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slider-container",
    class: _vm.basicdata.containerClass
  }, [_c('div', {
    staticClass: "slider-wrapper",
    style: (_vm.styleobj),
    on: {
      "touchmove": _vm.swipeMove,
      "touchstart": _vm.swipeStart,
      "touchend": _vm.swipeEnd,
      "mousedown": _vm.swipeStart,
      "mouseup": _vm.swipeEnd,
      "mousemove": _vm.swipeMove,
      "webkit-transition-end": _vm.onTransitionEnd,
      "transitionend": _vm.onTransitionEnd
    }
  }, [(!_vm.sliderinit.loop) ? [_vm._l((_vm.pages), function(item) {
    return [_c('div', {
      staticClass: "slider-item",
      style: (item.style),
      on: {
        "click": function($event) {
          _vm.$emit('click', item)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(item.title) + "\n                ")])]
  })] : _vm._e(), _vm._v(" "), (_vm.sliderinit.loop) ? [_vm._l((_vm.pages), function(item, index) {
    return (_vm.sliderinit.infinite) ? [(index + _vm.sliderinit.infinite - _vm.pages.length >= 0) ? _c('div', {
      staticClass: "slider-item",
      style: (item.style),
      on: {
        "click": function($event) {
          _vm.$emit('click', item)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()] : _vm._e()
  }), _vm._v(" "), (!_vm.sliderinit.infinite) ? [_c('div', {
    staticClass: "slider-item",
    style: (_vm.pages[_vm.pages.length - 1].style)
  }, [_vm._v(_vm._s(_vm.pages[_vm.pages.length - 1].title))])] : _vm._e(), _vm._v(" "), _vm._l((_vm.pages), function(item) {
    return [_c('div', {
      staticClass: "slider-item",
      style: (item.style),
      on: {
        "click": function($event) {
          _vm.$emit('click', item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])]
  }), _vm._v(" "), _vm._l((_vm.pages), function(item, index) {
    return (_vm.sliderinit.infinite) ? [(index - _vm.sliderinit.infinite < 0) ? _c('div', {
      staticClass: "slider-item",
      style: (item.style),
      on: {
        "click": function($event) {
          _vm.$emit('click', item)
        }
      }
    }, [_vm._v(_vm._s(item.title))]) : _vm._e()] : _vm._e()
  }), _vm._v(" "), (!_vm.sliderinit.infinite) ? [_c('div', {
    staticClass: "slider-item",
    style: (_vm.pages[0].style)
  }, [_vm._v(_vm._s(_vm.pages[0].title))])] : _vm._e()] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "slider-pagination slider-pagination-bullets"
  }, [_vm._l((_vm.pagenums), function(n) {
    return [_c('span', {
      staticClass: "slider-pagination-bullet",
      class: n - 1 === _vm.sliderinit.currentPage ? 'slider-pagination-bullet-active' : '',
      on: {
        "click": function($event) {
          _vm.slide(n - 1)
        }
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e77494e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-slider.vue
// module id = 98
// module chunks = 1